export const RouteChanged = function RouteChanged(routePath, string) {
    if (routePath && string ) {
        const regex = /:string/ig;
        return routePath.replaceAll(regex, string);
    } else {
        return routePath;
    }
};

export const ROUTE_SIGN_IN = "/sign-in";
export const ROUTE_SIGN_UP = "/sign-up";

export const ROUTE_PHONE_OTP = "/phone-validate/:string";

export const ROUTE_COMPLETE_PROFILE = "/complete-profile/:string";

export const ROUTE_FORGOT_PASSWORD = "/forgot-password";
export const ROUTE_RESET_PASSWORD = "/reset-password/:string";

export const ROUTE_DASHBOARD = "/dashboard";

export const ROUTE_VIDEO_PAGE = "/video-list";
export const ROUTE_VIDEO_INFO_PAGE = "/video-info/:string";

export const ROUTE_TEST_SERIES_PAGE = "/test-series";
export const ROUTE_PRACTISE_TEST_PAGE = "/quizzes";

export const ROUTE_EXAM_RULES_PAGE = "/exam-rules/:string";

export const ROUTE_EXAM_PAGE = "/exam-page/:string";

export const ROUTE_MY_PROFILE = "/my-profile";

export const ROUTE_EXAM_REPORT = "/exam-report/:string";

export const ROUTE_EXAM_SINGLE_REPORT = "/exam-single-report/:string";

export const ROUTE_EXAM_REPORT_DETAILS = "/exam-report-details/:string";



